import { ReportsViewOnFetchDataEpic } from './ReportsViewOnFetchDataEpic';
import { ReportsViewOnInitEpic } from './ReportsViewOnInitEpic';
import { ReportsViewOnRouteEpic } from './ReportsViewOnRouteEpic';

export const rootReportsViewEpics = [
  ReportsViewOnInitEpic,
  ReportsViewOnRouteEpic,
  ReportsViewOnFetchDataEpic,
];
